module.exports = __webpack_public_path__ + "img/rank1.e79d5436.png";